import { render } from "./FooterLinkComponent.vue?vue&type=template&id=40f66e64&ts=true"
import script from "./FooterLinkComponent.vue?vue&type=script&lang=ts"
export * from "./FooterLinkComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__